import { api } from "./api";

const orderinvoiceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInvoices: builder.query({
      query: () => "sales_master",
      providesTags: ["sales_master"],
    }),
    getInvoiceByInv: builder.query({
      query: (inv) => `orderByInvc/${inv}`,
      providesTags: ["sales_master"],
    }),
    bothSalesItems: builder.query({
      query: (invId) => ({
        url: `/both_sales?invId=${invId}`,
      }),
      providesTags: ["sales_master"],
    }),
    addNewSales: builder.mutation({
      query: (datas) => ({
        url: "create_sales",
        method: "POST",
        body: datas,
      }),
      invalidatesTags: ["sales_master"],
    }),
    addInvoice: builder.mutation({
      query: (newCategory) => ({
        url: "orders-two",
        method: "POST",
        body: newCategory,
      }),
      invalidatesTags: ["sales_master"],
    }),
    removeInvoice: builder.mutation({
      query: (id) => ({
        // url: `orders2/${id}`,
        url: `orders2s?inv_no=${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["sales_master"],
    }),
    editInvoice: builder.mutation({
      query: (editData) => ({
        url: `orders2`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["sales_master"],
    }),
  }),
});

export const {
  useGetInvoicesQuery,
  useGetInvoiceByInvQuery,
  useBothSalesItemsQuery,
  useAddNewSalesMutation,
  useAddInvoiceMutation,
  useRemoveInvoiceMutation,
  useEditInvoiceMutation,
} = orderinvoiceApi;
